import React from 'react';
import { Linkedin, Instagram, Mail } from 'lucide-react';

const founders = [
  {
    name: 'Rahul Bhardwaj',
    role: 'Founder & Director',
    quote: 'Committed to delivering premium solutions and reliable hygiene to every home.',
    linkedin: 'https://www.linkedin.com/in/rahul-bhardwaj-op/',
    instagram: 'https://www.instagram.com/dankbhardwajrahul/',
    email: 'rahul.bhardwaj@fbd-cleaning.com',
    initials: 'RB',
    color: '#1a66c9',
  },
  {
    name: 'Sparsh Chhabra',
    role: 'Founder & Director',
    quote: 'Guiding operational excellence and building trusted connections with our users.',
    linkedin: 'https://www.linkedin.com/in/sparsh-chhabra-189547137/',
    instagram: 'https://www.instagram.com/sparsh.chhabra_/',
    email: 'sparsh.chhabra@fbd-cleaning.com',
    initials: 'SC',
    color: '#159a3b',
  },
];

const FoundersSection = () => {
  return (
    <section id="founders" className="py-20 bg-secondary/40">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <p className="text-primary font-semibold uppercase tracking-wide text-sm mb-2">Our Leadership</p>
          <h2 className="font-display font-extrabold text-3xl md:text-4xl text-foreground">Meet Our Founders</h2>
          <p className="mt-3 text-muted-foreground max-w-xl mx-auto">
            The visionaries behind FBD Cleaning's commitment to quality and service.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {founders.map((f) => (
            <div
              key={f.name}
              className="bg-white rounded-2xl p-8 shadow-sm border border-border hover:shadow-lg hover:-translate-y-1 transition-all duration-300 text-center"
            >
              <div
                className="h-20 w-20 rounded-full mx-auto flex items-center justify-center text-white font-display font-bold text-2xl"
                style={{ backgroundColor: f.color }}
              >
                {f.initials}
              </div>
              <h3 className="mt-5 font-display font-bold text-xl text-foreground">{f.name}</h3>
              <p className="text-primary text-sm font-semibold">{f.role}</p>
              <p className="mt-4 text-muted-foreground italic">“{f.quote}”</p>
              <div className="mt-6 flex items-center justify-center gap-3">
                <a href={f.linkedin} target="_blank" rel="noreferrer" className="p-2.5 rounded-full bg-secondary hover:bg-primary hover:text-white transition-colors">
                  <Linkedin className="h-4 w-4" />
                </a>
                <a href={f.instagram} target="_blank" rel="noreferrer" className="p-2.5 rounded-full bg-secondary hover:bg-primary hover:text-white transition-colors">
                  <Instagram className="h-4 w-4" />
                </a>
                <a href={`mailto:${f.email}`} className="p-2.5 rounded-full bg-secondary hover:bg-primary hover:text-white transition-colors">
                  <Mail className="h-4 w-4" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FoundersSection;
